﻿import flattenObject from 'flatten-object-strict';

import {
    pageIsLoadingAction, 
    pageLoadedAction, 
    pageCurrentStepAction, 
    pageHasErroredAction, 
    pageErrorAction
} from '../../../State/actions';

import LfWebService from '../../../Services/LfWebService';

export function insuranceGuideUpdateFormDataAction(data) {
    return {
        type: 'INSURANCE_GUIDE_UPDATE_FORM_DATA',
        formData: data
    };
}

export function submitInsuranceGuideAction() {
    const lfWebService = new LfWebService();

    return (dispatch, getState) => {
        const { insuranceGuideFormData } = getState();

        let flattenedData = flattenObject(insuranceGuideFormData.formData);
        let data = Object.keys(flattenedData).reduce((agg, key) => {
            agg[key] = flattenedData[key] === 'ja' ? true : (flattenedData[key] === 'nej' ? false : flattenedData[key] );
            return agg; 
        }, {});

        // this does a redirect to the result page url with data supplied in query var
        lfWebService.insuranceGuide(data);
    }
}